module.exports = __webpack_public_path__ + "img/arrow.71d82a7c.svg";